var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigationWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Tour") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets_Export",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,9 L8,9 C7.4,9 7,9.4 7,10 L7,14 L9,14 L9,11 L13,11 L13,13.5 L16.5,10 L13,6.5 L13,9 Z M11,0 C4.9,0 0,4.9 0,11 C0,17.1 4.9,22 11,22 C17.1,22 22,17.1 22,11 C22,4.9 17.1,0 11,0 Z M18.73,11.58 L11.54,18.8 C11.19,19.07 10.75,19.07 10.39,18.8 L3.2,11.58 C2.93,11.22 2.93,10.78 3.2,10.42 L10.39,3.2 C10.74,2.93 11.18,2.93 11.54,3.2 L18.73,10.42 C19.09,10.69 19.09,11.22 18.73,11.58 Z",
    id: "Tour",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationWhite);
export default __webpack_public_path__ + "static/media/navigation_white.7fa0b5208e5251be7f62f0d41d55753d.svg";
export { ForwardRef as ReactComponent };